var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "select_service_wrapper" },
    [
      !_vm.teamMemberData
        ? [
            _vm._m(0),
            _vm._m(1),
            _c("div", { staticClass: "row m-0" }, [
              _c("div", { staticClass: "col-xs-6 text-left service-header" }, [
                _c("p", [_vm._v(_vm._s(_vm.currentService.name))]),
                _c("p", { staticClass: "service-description pl-10 fw-400" }, [
                  _c("span", [_vm._v("Renews")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("dateFormat")(
                          _vm.currentService.id === 15
                            ? _vm.nextOneYear
                            : _vm.currentService.valid_until
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "col-xs-6 text-right" }, [
                _vm._v(" $" + _vm._s(_vm.currentService.price)),
                _c("span", { staticClass: "service-description" }, [
                  _vm._v(" per year"),
                ]),
              ]),
            ]),
            _vm._m(2),
            _vm._m(3),
            _vm._m(4),
            _c("div", { staticClass: "row m-0" }, [
              _c("div", { staticClass: "col-xs-10 text-left service-header" }, [
                _c(
                  "ul",
                  { staticClass: "service-description pl-20" },
                  [
                    _vm.serviceSelected.id === 16
                      ? [
                          _c("li", { staticClass: "pb-10" }, [
                            _vm._v("Includes unlimited reports"),
                          ]),
                          _c("li", { staticClass: "pb-10" }, [
                            _vm._v(
                              "Upgrading will restart the clock and give a pro-rated credit"
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm.selectedRecords
                      ? [
                          _c("li", { staticClass: "pb-10" }, [
                            _vm._v(
                              "Includes " + _vm._s(_vm.selectedRecords.name)
                            ),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm.serviceSelected.id === 16
                ? _c("div", { staticClass: "col-xs-2 text-right" }, [
                    _vm._v(
                      " +$" +
                        _vm._s(
                          _vm.serviceSelected.price - _vm.currentService.price
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
              (_vm.serviceSelected.id === 1 ||
                _vm.serviceSelected.id === 13 ||
                _vm.serviceSelected.id === 14) &&
              _vm.selectedRecords
                ? _c("div", { staticClass: "col-xs-2 text-right" }, [
                    _vm._v(" +$" + _vm._s(_vm.selectedRecords.price) + " "),
                  ])
                : _vm._e(),
            ]),
          ]
        : [
            _vm._m(5),
            _vm._m(6),
            _c("div", { staticClass: "col-xs-12 p-0 mb-20 mt-8" }, [
              _c("div", { staticClass: "col-xs-6 text-left service-header" }, [
                _c("p", [
                  _vm._v(" Total limit : "),
                  _vm.isREP
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.teamMemberData.total_limit - 1)),
                      ])
                    : _c("span", [
                        _vm._v(_vm._s(_vm.teamMemberData.total_limit)),
                      ]),
                ]),
                _c("p", { staticClass: "service-description mb-5" }, [
                  _c("span", [_vm._v("Renews")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("dateFormat")(_vm.teamMemberData.valid_until)
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "col-xs-6 text-right font-18 fw-500" }, [
                _vm.isREP
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.teamMemberData.current_utilization - 1)
                      ),
                    ])
                  : _c("span", [
                      _vm._v(_vm._s(_vm.teamMemberData.current_utilization)),
                    ]),
              ]),
            ]),
            _vm._m(7),
            _vm._m(8),
            _vm._m(9),
            _c("div", { staticClass: "col-xs-12 p-0 mb-20 mt-8" }, [
              _c("div", { staticClass: "col-xs-12 p-0" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-5 text-left service-header" },
                  [
                    _c("p", [
                      _vm._v(
                        "Additional team members limit : " +
                          _vm._s(_vm.selectedRecords.value) +
                          " Members"
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-7 text-right font-18 fw-400" },
                  [
                    _vm.teamMemberData.total_limit <=
                      _vm.teamMemberData.default_limit ||
                    _vm.teamMemberData.isRenewal
                      ? [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 p-0 text-right" },
                            [
                              _c("div", { staticClass: "col-xs-10 p-0" }, [
                                _vm._v("Total Price:"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-2 pr-0 word-break fw-500",
                                },
                                [
                                  _vm._v(
                                    "$" + _vm._s(_vm.selectedRecords.price)
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 p-0 text-right" },
                            [
                              _c("div", { staticClass: "col-xs-10 p-0" }, [
                                _vm._v("Actual price:"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-2 pr-0 word-break fw-500",
                                },
                                [
                                  _vm._v(
                                    "$" + _vm._s(_vm.selectedRecords.price)
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "col-xs-12 p-0" }, [
                _vm._m(10),
                _c(
                  "div",
                  { staticClass: "col-xs-7 text-right font-18 fw-400" },
                  [
                    _vm.teamMemberProRata
                      ? _c("div", { staticClass: "col-xs-12 p-0 text-right" }, [
                          _c("div", { staticClass: "col-xs-10 p-0" }, [
                            _vm._v("Final price:"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-xs-2 pr-0 word-break fw-500" },
                            [
                              _vm._v(
                                "$" + _vm._s(_vm.teamMemberProRata.netPrice)
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-sm-6 text-left" }, [
        _vm._v("Current Service"),
      ]),
      _c("div", { staticClass: "col-sm-6 text-right" }, [
        _vm._v("Current Price"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-sm-6 text-left" }, [
        _vm._v("Upgrade Service"),
      ]),
      _c("div", { staticClass: "col-sm-6 text-right" }, [
        _vm._v("Additional Price"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0 font-18 fw-400" }, [
      _c("div", { staticClass: "col-sm-6 text-left" }, [
        _vm._v("Current Account Add On"),
      ]),
      _c("div", { staticClass: "col-sm-6 text-right" }, [
        _vm._v("Current Utilization"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-sm-6 text-left font-18 fw-400" }, [
        _vm._v("Upgrade Team Members"),
      ]),
      _c("div", { staticClass: "col-sm-6 text-right font-18 fw-400" }, [
        _vm._v("Price"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row col-xs-12 m-0" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-5 text-left service-header" }, [
      _c("ul", [
        _c("li", { staticClass: "fw-400 text-secondary font-16" }, [
          _vm._v(
            " Charges for add-ons may be prorated to align with validity of a previous Team Member upgrade. "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }